import React, { useState, useEffect } from 'react'
import dynamic from 'next/dynamic'
import Link from 'next/link'
import Image from 'next/image'
const Navbar = dynamic(() => import('../../components/Layouts/Navbar', { ssr: false }));
const Footer = dynamic(() => import('../../components/Layouts/Footer', { ssr: false }));
const Breadcrumb = dynamic(() => import('../../components/Layouts/Breadcrumb', { ssr: false }));
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { HTMLParser } from '../../components/Common/Functions';
import {
    faFile,
} from '@fortawesome/free-solid-svg-icons';
import SideBarForm from '../../components/Common/SideBarForm';

// const sanitizeHTML = (htmlString) => {
//     if (typeof window === 'undefined') return htmlString; // Skip during SSR

//     const parser = new DOMParser();
//     const doc = parser.parseFromString(htmlString, 'text/html');

//     // Apply Tailwind classes to headings
//     const headings = doc.querySelectorAll('h1, h2, h3, h4, h5, h6');
//     headings.forEach(heading => {
//         heading.classList.add('font-semibold');
//         if (heading.tagName === 'H2') heading.classList.add('text-lg');
//         if (heading.tagName === 'H3') heading.classList.add('text-md');

//         // Remove nested <b>, <strong> tags inside headings
//         const boldTags = heading.querySelectorAll('b, strong');
//         boldTags.forEach(tag => {
//             tag.replaceWith(...tag.childNodes);
//         });
//     });

//     // Clean up spaces and unwanted elements
//     const elements = doc.querySelectorAll('*');
//     elements.forEach(el => {
//         // Remove empty paragraphs
//         if (el.tagName === 'P' && !el.textContent.trim()) {
//             el.remove();
//         }
//         // Remove bullets
//         el.innerHTML = el.innerHTML
//             .replace(/&bull;/g, '')
//             .replace(/\s+/g, ' ')
//             .trim();
//     });

//     return doc.body.innerHTML;
// };

const PostPage = ({ data, isMobile }) => {
    const [Infographics, setInfographics] = useState([])
    const [InfographicsDescription, setInfographicsDescription] = useState("")
    useEffect(() => {
        if((data) != null){
            setInfographics(data)
            setTrigger(true)
        }else{
            router.push('/404')
        }
    }, [data])
    const [trigger, setTrigger] = useState(false);
    useEffect(() => {
        if (Infographics?.description) {
            HTMLParser(Infographics?.description, setInfographicsDescription)
        }
    }, [trigger]);

    const [scrolled, setScrolled] = useState(0)
    const [scrolledStatus, setScrolledStatus] = useState(false)
    useEffect(() => {
        const onScroll = () => setScrolled(window.pageYOffset);
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    useEffect(() => {
        if (scrolled > 20) {
            setScrolledStatus(true)
        }
    }, [scrolled])

    return (
        <>
            <Navbar />
            {/* <HeroBanner
                background={process.env.IMG_CDN + "img/about-us/jpg/banner/banner_1.jpg"}
                title={<>{Infographics?.name}</>}
                description={posts?.data?.report_id.value}
                buttonTitle={<>Download</>}
            /> */}
            <div className='mt-65'>
                <Breadcrumb />
            </div>
            <div className="w-11/12 mx-auto my-10 xl:max-w-screen max-w-screen-2xl">
                <h1 className='mb-4 text-2xl font-semibold'>{Infographics?.name}</h1>
                <div className='grid grid-cols-12 gap-4'>
                    <div className='col-span-12 xl:col-span-9 lg:col-span-8'>
                        <div>
                            {(Infographics?.image) ?
                                <Image
                                    className='w-full h-full'
                                    priority={true}
                                    src={process.env.IMG_CDN + Infographics?.image}
                                    alt={Infographics?.image_alt}
                                    width={2000}
                                    height={2000}
                                />:
                                <>
                                    <div className="flex items-center justify-center min-h-screen">
                                        <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                                    </div>
                                </>
                            }
                        </div>
                        {/* <div className='InfoGraphicsDetails' dangerouslySetInnerHTML={{ __html: sanitizeHTML(InfographicsDescription) }}></div> */}
                        <div dangerouslySetInnerHTML={{ __html: InfographicsDescription }}></div>
                    </div>
                    {  (isMobile) ? scrolledStatus &&
                        <div className='col-span-12 xl:col-span-3 lg:col-span-4'>
                            {/* Sample Page Button */}
                            <Link href={process.env.APP_URL + "/sample-request/" + data?.report_id?.slug}>
                                <div className='px-4 py-3 mb-4 border-2 border-blue-700 rounded-md'>
                                    <FontAwesomeIcon icon={faFile} className='pr-2' /> Request Sample Page
                                </div>
                            </Link>
                            {/* Sample Page Button */}
                            {/* Report Button */}
                            <Link href={process.env.APP_URL + "/report-store/" + data?.report_id?.slug}>
                                <div className='text-[16px] mb-4 rounded-md font-semibold bg-[#ecf5fe]  px-4 py-3 border-2 border-blue-700'>
                                    <FontAwesomeIcon icon={faFile} className='pr-2' /> View Report
                                </div>
                            </Link>
                            {/* Report Button */}
                            <div className='sticky top-20'>
                                <SideBarForm
                                    title="Download Infographics"
                                    page_name='Infographics Page'
                                    product_name = {Infographics?.name}
                                    form_name='infographics-page-form'
                                    endpoint="/enquiry/infographics-request"
                                />
                            </div>
                        </div>:
                        <div className='col-span-12 xl:col-span-3 lg:col-span-4'>
                            {/* Sample Page Button */}
                            <Link href={process.env.APP_URL + "/sample-request/" + data?.report_id?.slug}>
                                <div className='px-4 py-3 mb-4 border-2 border-blue-700 rounded-md'>
                                    <FontAwesomeIcon icon={faFile} className='pr-2' /> Request Sample Page
                                </div>
                            </Link>
                            {/* Sample Page Button */}
                            {/* Report Button */}
                            <Link href={process.env.APP_URL + "/report-store/" + data?.report_id?.slug}>
                                <div className='text-[16px] mb-4 rounded-md font-semibold bg-[#ecf5fe]  px-4 py-3 border-2 border-blue-700'>
                                    <FontAwesomeIcon icon={faFile} className='pr-2' /> View Report
                                </div>
                            </Link>
                            {/* Report Button */}
                            <div className='sticky top-20'>
                                <SideBarForm
                                    title="Download Infographics"
                                    page_name='Infographics Page'
                                    product_name = {Infographics?.name}
                                    form_name='infographics-page-form'
                                    endpoint="/enquiry/infographics-request"
                                />
                            </div>
                        </div>
                    }
                </div>
            </div>
            {scrolledStatus &&
            <Footer />
            }
        </>
    );
};

export async function getServerSideProps({ req, res, resolvedUrl }) {
    const UA = req.headers['user-agent'];
    const isMobile = Boolean(UA.match(
        /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
    ))
    let redirecting = {
        redirect: {
            permanent: false,
            destination: "/404"
        }
    }

    let slug = resolvedUrl;
    try {
        let cleanedSlug = slug.replace(/\/$/, '');
        cleanedSlug = cleanedSlug.replace(/\/infographics\//, '');
        let apiUrl = process.env.API_URL + '/infographics/' + cleanedSlug;
        const output = await fetch(apiUrl, { method: 'GET', headers: { 'Content-Type': 'application/json', } });
        const response = await output.json();
        console.log(apiUrl,response);
        if (response?.data?.meta) {
            return {
                props: {
                    title: (response?.data.meta.meta_title) ? response?.data.meta.meta_title : "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
                    description: (response?.data.meta.meta_description) ? response?.data.meta.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
                    keywords: (response?.data.meta.meta_keywords) ? response?.data.meta.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
                    data: response?.data ? response?.data : [],
                    isMobile: isMobile
                }
            }
        } else {
            if( response?.data){
                return {
                    props:{
                            title: "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
                            description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
                            keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
                            data: response?.data ? response?.data : [],
                            isMobile: isMobile
                    }
                };
            }else{
                return redirecting;
            }
        }
    } catch (error) {
        return redirecting;
    }
}

export default PostPage;